<template>
  <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 0C4.7 0 2 2.7 2 6H0L3 10L6 6H4C4 3.78 5.78 2 8 2V0ZM13 2L10 6H12C12 8.22 10.22 10 8 10V12C11.3 12 14 9.3 14 6H16L13 2Z"
      fill="currentColor" />
  </svg>
</template>

<script>
export default {
  name: 'Refresh',
};
</script>
